/**
 * Утилиты для управления кешем приложения
 */

/**
 * Полная очистка всего кеша приложения
 * Включает: localStorage, sessionStorage, cookies, Service Worker cache
 */
export const clearAppCache = async (): Promise<void> => {
    try {
        // 1. Очищаем localStorage (кроме токенов, они очищаются отдельно)
        const keysToPreserve = ['jwt_token', 'last_login_time', 'i18nextLng'];
        const keysToRemove: string[] = [];

        // Собираем все ключи для удаления
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && !keysToPreserve.includes(key)) {
                keysToRemove.push(key);
            }
        }

        // Удаляем собранные ключи
        keysToRemove.forEach(key => localStorage.removeItem(key));

        // 2. Очищаем sessionStorage полностью
        sessionStorage.clear();

        // 3. Очищаем Service Worker cache (если есть)
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
            );
        }

        console.log('✅ Кеш приложения успешно очищен');
    } catch (error) {
        console.error('❌ Ошибка при очистке кеша:', error);
    }
};

/**
 * Полная очистка всего кеша включая токены и настройки
 * Используется при logout
 */
export const clearAllCache = async (): Promise<void> => {
    try {
        // 1. Полная очистка localStorage
        localStorage.clear();

        // 2. Полная очистка sessionStorage
        sessionStorage.clear();

        // 3. Очищаем Service Worker cache (если есть)
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
            );
        }

        console.log('✅ Весь кеш приложения успешно очищен (включая токены)');
    } catch (error) {
        console.error('❌ Ошибка при полной очистке кеша:', error);
    }
};

/**
 * Очистка кеша при перезагрузке страницы
 * Более мягкая версия - сохраняет токены и настройки языка
 */
export const clearCacheOnReload = async (): Promise<void> => {
    try {
        // Очищаем только временные данные из sessionStorage
        sessionStorage.clear();

        console.log('✅ Временный кеш очищен при перезагрузке');
    } catch (error) {
        console.error('❌ Ошибка при очистке кеша при перезагрузке:', error);
    }
};

